/**
 * Animated solid chrome underlay — opacity driven by `transition` SharedValue (0…1).
 */
import React from 'react';
import { StyleSheet, type StyleProp, type ViewStyle } from 'react-native';
import Animated, { Extrapolation, interpolate, useAnimatedStyle, type SharedValue } from 'react-native-reanimated';

type ConditionalSolidLayerProps = {
  transition: SharedValue<number>;
  backgroundColor: string;
  style?: StyleProp<ViewStyle>;
};

export function ConditionalSolidLayer({
  transition,
  backgroundColor,
  style,
}: ConditionalSolidLayerProps) {
  const layer_style = style ?? StyleSheet.absoluteFill;
  const opacity_style = useAnimatedStyle(() => ({
    opacity: interpolate(transition.value, [0, 1], [0, 1], Extrapolation.CLAMP),
  }));

  return (
    <Animated.View
      pointerEvents="none"
      collapsable={false}
      style={[layer_style, { backgroundColor }, opacity_style]}
    />
  );
}
